import { candyCaneLogDecorator } from '@decorators/candyCaneLogDecorator';

export { candyCaneLogDecorator };
